import { useEffect, useState } from "react";
const CURRENCY_BY_COUNTRY = {
  US: "USD",
  IN: "INR",
  GB: "GBP",
  CA: "CAD",
  AU: "AUD",
};
function getCurrencyByCountryCode(code) {
  if (!code) return "USD";
  return CURRENCY_BY_COUNTRY[code] || "USD";
}
export default function useCountryCode() {
  const [country, setCountry] = useState(null); 
  const [currency, setCurrency] = useState(null); 
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  useEffect(() => {
    const controller = new AbortController();

    (async () => {
      try {
        setLoading(true);
        setError(null);
        const res = await fetch("https://ipinfo.io/json", {
          signal: controller.signal,
        });
        const data = await res.json().catch(() => ({}));
        const code = (data && data.country) || null;

        setCountry(code);
        setCurrency(getCurrencyByCountryCode(code));
      } catch (e) {
        setCountry(null);
        setCurrency(null);
        setError(e?.message || "geo lookup failed");
      } finally {
        setLoading(false);
      }
    })();
    return () => controller.abort();
  }, []);

  return { country, currency, loading, error };
}



// kullu maanali 